/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_No_EventsInputs */

const en_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selected Event Group has no events.`)
};

const fr_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d'événements sélectionné ne contient aucun événement.`)
};

const de_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ausgewählte Ereignisgruppe enthält keine Ereignisse.`)
};

const it_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo eventi selezionato non contiene eventi.`)
};

const ru_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранная группа событий не содержит событий.`)
};

const es_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de eventos seleccionado no tiene eventos.`)
};

const zh_cn2_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选事件组没有事件。`)
};

const ja_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントグループにはイベントがありません。`)
};

const hi_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह में कोई इवेंट नहीं हैं।`)
};

const pt_pt2_offline_sync_no_events = /** @type {(inputs: Offline_Sync_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos selecionado não tem eventos.`)
};

/**
* | output |
* | --- |
* | "The selected Event Group has no events." |
*
* @param {Offline_Sync_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_no_events = /** @type {((inputs?: Offline_Sync_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_no_events(inputs)
	if (locale === "de") return de_offline_sync_no_events(inputs)
	if (locale === "it") return it_offline_sync_no_events(inputs)
	if (locale === "ru") return ru_offline_sync_no_events(inputs)
	if (locale === "es") return es_offline_sync_no_events(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_no_events(inputs)
	if (locale === "ja") return ja_offline_sync_no_events(inputs)
	if (locale === "hi") return hi_offline_sync_no_events(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_no_events(inputs)
	return en_offline_sync_no_events(inputs)
});